import React from 'react'
import update from 'immutability-helper';
import { browserHistory } from 'react-router'

import GlobalUtilities from './GlobalUtilities'
import NavLink from '../Routes/NavLink'

import { group } from '../../core/controllers/Group';
import { modal } from '../../core/utilities/modal'

export default class GroupEdit extends React.Component {
    constructor(props) {
        super(props);
        var self = this;

        this.state = {
            groupID : props.groupID,
            disposalAmount: 0,
            waterAmount: 0,
            sewageAmount: 0
        };
    }

    componentDidMount() {
        if(!this.props.newGroup){
            group.setGroupID(this.state.groupID);
            group.getGroup(this);
        } else {
            group.setGroupID(0);
            group.setDefaultState(this);
        }
    }

    componentWillUpdate(nextProps, nextState) {

    }

    handleTitleChange(e){
        this.setState({
            groupData: update(this.state.groupData, {
                building_group_name: {$set: e.target.value
                }}
            )
        });
    }

    handleSaveGroupData(e){
        var newGroup = this.props.newGroup;
        group.saveGroup(this, function(response) {
            modal.resetBackDrop();
            if(newGroup) {
                modal.showSuccess("Group Added!","This group has been added.");
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            } else {
                modal.showSuccess("Group Updated!","This group has been updated.");
            }
        });
    }

    handleDeleteGroup(e){
        group.deleteGroup(this);
    }

    render(){
        const associatedBuildings = this.state.associatedBuildings;
        const newGroup = this.props.newGroup;
        var groupData = this.state.groupData;
        if(newGroup || groupData == null) {
            return (
                <div>
                    <div class="col-md-8">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Group Information</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <form>
                                    <input type="hidden" class="tenant_id" name="tenant_id" value="" />
                                    <div class="row">
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label>Title</label>
                                                <input type="text" class="form-control tenant-info" name="firstname" placeholder="Group Title" id="firstname" onChange={this.handleTitleChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="content">
                                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleSaveGroupData.bind(this)}>
                                            Create Group
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="header">
                                <h4 class="title"><i class="fa fa-building-o"></i> Associated Building(s)</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                TBC
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <div class="col-md-8">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Group Information</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <form>
                                    <input type="hidden" class="tenant_id" name="tenant_id" value="" />
                                    <div class="row">
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label>Title</label>
                                                <input type="text" value={groupData.building_group_name} class="form-control tenant-info" name="firstname" placeholder="Tenants firstname" id="firstname" onChange={this.handleTitleChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="content">
                                            <button type="button" id="delete-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleDeleteGroup.bind(this)}>
                                            Delete
                                            </button>
                                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleSaveGroupData.bind(this)}>
                                            Update
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="header">
                                <h4 class="title"><i class="fa fa-building-o"></i> Associated Building(s)</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                            <ul>
                            {associatedBuildings != null ? (
                                associatedBuildings.map(function(building, index){
                                    return (
                                        <li key={index}>
                                            <NavLink to={/building/ + building.id}>{building.name}</NavLink>
                                        </li>
                                    )
                                })
                            ) : (
                                <p>No buildings currently associated with this group.</p>
                            )}
                            </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card">
                            <div class="header">
                                <h4 class="title"><i class="pe-7s-piggy"></i><small><i class="pe-7s-angle-right"></i></small> Global Utilities</h4>
                                <p class="category">Enter the total monthly cost for each utilty to have your tenants split the cost.</p>
                            </div>
                            <GlobalUtilities groupId={this.state.groupID} waterAmount={this.state.waterAmount} disposalAmount={this.state.disposalAmount} sewageAmount={this.state.sewageAmount} />
                        </div>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Group/GroupEdit.jsx